module.exports = __webpack_public_path__ + "img/fastcharger-in-progress.d5ce7ca6.png";